import React, { useEffect, useState } from 'react';
import { tvApi, movieApi } from 'api';
import { Loader } from 'Components/Loader';
import styled from 'styled-components';
import { Section } from 'Components/Section';
import { Poster } from 'Components/Poster';
import { Helmet } from 'react-helmet';

const Container = styled.div`
  padding: 0 20px;
`;

const Title = styled.h1`
  display: flex;
  height: 100px;
  align-items: center;
  font-weight: 600;
  opacity: 0.6;
  font-size: 32px;
  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const Home = () => {
  const [moviePopular, setMoviePopular] = useState(null);
  const [tvPopular, setTvPopular] = useState(null);
  const [loading, setLoading] = useState(true);

  const getApi = async () => {
    try {
      const {
        data: { results: moviePopular }
      } = await movieApi.popular();
      setMoviePopular(moviePopular);
      const {
        data: { results: tvPopular }
      } = await tvApi.popular();
      setTvPopular(tvPopular);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getApi();
  }, []);
  return (
    <>
      <Helmet>
        <title>홈 - ScFlix</title>
      </Helmet>
      {loading ? (
        <Loader />
      ) : (
        <Container>
          <Title>인기 TV 프로그램</Title>
          {tvPopular && tvPopular.length > 0 && (
            <Section>
              {tvPopular.map(
                (tv, index) =>
                  index < 10 && (
                    <Poster
                      key={tv.id}
                      id={tv.id}
                      title={tv.name ? tv.name : tv.original_name}
                      posterUrl={tv.poster_path}
                      rating={tv.vote_average}
                      year={
                        tv.first_air_date && tv.first_air_date.substring(0, 4)
                      }
                      isMovie={false}
                    />
                  )
              )}
            </Section>
          )}
          <Title>인기 영화</Title>
          {moviePopular && moviePopular.length > 0 && (
            <Section>
              {moviePopular.map(
                (movie, index) =>
                  index < 10 && (
                    <Poster
                      key={movie.id}
                      id={movie.id}
                      title={movie.title ? movie.title : movie.original_title}
                      posterUrl={movie.poster_path}
                      rating={movie.vote_average}
                      year={
                        movie.release_date && movie.release_date.substring(0, 4)
                      }
                      isMovie={true}
                    />
                  )
              )}
            </Section>
          )}
        </Container>
      )}
    </>
  );
};
